import { OfbizList, OfbizForm } from "@urbannex/ofbiz-forms";
import { ConfigOptions, CustomContainerItem, ProductEditContainerComponent, getColumnFieldTitles, getFieldSets, getFields, getIdFieldName, getTarget, getTitleDescriptionField } from "@urbannex/view-containers";
import { FEAT_TYPE_FORMS } from "./forms";
import { NbMenuItem } from "@nebular/theme";

export const featureTypeOptions:ConfigOptions = {
    name:"",
    title:"Feature Types Component",
    appContext:"catalog",
    /* defaultParameters:[
        {productCategoryId:"CATALOG1_SEARCH"}
    ], */
    menuAndTitleOptions:{
        path:"feature",
        headerTitle:"Feature Type Information",
        menuItems:[],
        menuTag:"featureTypesMenu"
    },
    listForm:new OfbizList({
        listType:"grid",
        fieldFormName:"",
        fieldFormLocation:"local",
        listFormName:"ListFeatureTypes",//"ListProducts",
        //listFormLocation:"component://product/widget/catalog/ProductForms.xml",
        listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
        //columnFields:getFields("ListProducts",FEAT_TYPE_FORMS),
        columnFields:getFields("ListFeatureTypes",FEAT_TYPE_FORMS),
        //columnFieldTitles:getColumnFieldTitles("ListProducts",FEAT_TYPE_FORMS),
        columnFieldTitles:getColumnFieldTitles("ListFeatureTypes",FEAT_TYPE_FORMS),
        /* remoteFormData:{
        formData:{
            formName:"ListProducts",
            formLocation:"component://product/widget/catalog/ProductForms.xml",
            listType:"grid",
            viewIndex:1,
        },
        appContext:"catalog",
        parameters:{"productCategoryId":""}
        }, */
        remoteFormData:{
        formData:{
            formName:"ListFeatureTypes",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            listType:"grid",
            viewIndex:1,
        },
        appContext:"catalog"
        },
        emptyListMessage:"No products found.  Please create new or add existing."
    }),
    findForm:undefined,
    addForm:new OfbizForm({
        local:true,
        formName:"EditFeatureType",
        formLocation:"component://kwikstore/widget/FeatureForms.xm",
        fields:getFields("EditFeatureType",FEAT_TYPE_FORMS),
        titleDescriptionField:getTitleDescriptionField("EditFeatureType",FEAT_TYPE_FORMS),
        idFieldName:getIdFieldName("EditFeatureType",FEAT_TYPE_FORMS),
        fieldSets:getFieldSets("EditFeatureType",FEAT_TYPE_FORMS),
    }),
    breadCrumbData:{
        displayPrefix:"Products for ",
        label:"",
        level:1,
        selectedValue:{
            "event":"list",
            "type":"ListProducts",
            "data":{
            formData:{
                listType:"grid",
                //formName:"ListProducts",
                formName:"ListProductCategoryMembers",
                //formLocation:"component://product/widget/catalog/ProductForms.xml",
                formLocation:"component://kwikstore/widget/FeatureForms.xm",
            },
            "endPoint":"",
            //"parameters":{"productCategoryId":"","noConditionFind":"Y"}
            "parameters":{"productCategoryId":""}
            }
        },
        addFormText:"Create Product",
        editFormText:"Update Product"
    },
    actions:[],
    settings:[],
    /* relations:[
        {
        title:"Prices",
        titleGroup:"Product Financials",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Create new price for",
        listContainerTitle:"Prices for",
        addFormName:"",
        listFormName:"",
        addForm:new OfbizForm({
            formName:"AddProductPriceRest",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            fields:getFields("AddProductPriceRest",FEAT_TYPE_FORMS),
            target:getTarget("AddProductPriceRest",FEAT_TYPE_FORMS),
            appContext:"catalog",
            local:true,
            entityName:"ProductPrice"
        }),
        listForm:new OfbizList({
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            listFormName:"UpdateProductPriceRest",
            listType:"grid",
            columnFields:getFields("UpdateProductPriceRest",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("UpdateProductPriceRest",FEAT_TYPE_FORMS),
            emptyListMessage:"No prices found.  Please add existing or create new."
        })
        },
        {
        title:"Content",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add existing content to ",
        listContainerTitle:"Associated Content for ",
        addFormName:"ListProductContentInfosRest",
        listFormName:"",
        addForm:new OfbizForm({
            local:true,
            formName:"AddProductContentAssocRest",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            fields:getFields("AddProductContentAssocRest",FEAT_TYPE_FORMS),
            titleDescriptionField:getTitleDescriptionField("AddProductContentAssocRest",FEAT_TYPE_FORMS),
            idFieldName:getIdFieldName("AddProductContentAssocRest",FEAT_TYPE_FORMS),
        }),
        listForm:new OfbizList({
            listType:"grid",
            fieldFormName:"",
            fieldFormLocation:"local",
            listFormName:"ListProductContentInfosRest",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            columnFields:getFields("ListProductContentInfosRest",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("ListProductContentInfosRest",FEAT_TYPE_FORMS),
            emptyListMessage:"No content found.  Please add existingor create new."
        })
        },
        {
        title:"Geos",
        titleGroup:"Product Classification",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add geography to product",
        listContainerTitle:"Geographies for product",
        addFormName:"AddProductGeo",
        listFormName:"ListProductGeos",
        addForm:new OfbizForm({
            formName:"AddProductGeo",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            local:true,
            fields:getFields("AddProductGeo",FEAT_TYPE_FORMS),
            appContext:"catalog"
        }),
        listForm:new OfbizList({
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            listFormName:"ListProductGeos",
            listType:"grid",
            columnFields:getFields("ListProductGeos",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("ListProductGeos",FEAT_TYPE_FORMS),
            appContext:"catalog",
            idFieldName:"productId",
            emptyListMessage:"No geographies found for this product.  Please add."
        })
        },
        {
        title:"IDs",
        titleGroup:"Product Classification",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add Good Identification to product",
        listContainerTitle:"Product Good Identifications",
        addFormName:"AddProductGoodIdentification",
        listFormName:"UpdateProductGoodIdentifications",
        addForm:new OfbizForm({
            formName:"AddProductGoodIdentification",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            appContext:"catalog",
            fields:getFields("AddProductGoodIdentification",FEAT_TYPE_FORMS),
            local:true,
        }),
        listForm:new OfbizList({
            listFormName:"UpdateProductGoodIdentifications",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            listType:"grid",
            appContext:"catalog",
            columnFields:getFields("UpdateProductGoodIdentifications",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("UpdateProductGoodIdentifications",FEAT_TYPE_FORMS),
            emptyListMessage:"No identifications found for this product.  Please add exisiting or create new."
        })
        },
        {
        title:"Categories",
        titleGroup:"Product Classification",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add Product to Product Category",
        listContainerTitle:"Product Categories for this product",
        addFormName:"AddProductCategoryMember",
        listFormName:"UpdateProductCategoryMember",
        addForm:new OfbizForm({
            formName:"AddProductCategoryMember",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            local:true,
            appContext:"catalog",
            fields:getFields("AddProductCategoryMember",FEAT_TYPE_FORMS),
        }),
        listForm:new OfbizList({
            listType:"grid",
            listFormName:"UpdateProductCategoryMember",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            columnFields:getFields("UpdateProductCategoryMember",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("UpdateProductCategoryMember",FEAT_TYPE_FORMS),
            appContext:"catalog",
            emptyListMessage:"No categories associated with this product.  Please add existing or create new."
        })
        },
        {
        title:"Keywords",
        titleGroup:"Product Classification",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add Product Keyword",
        listContainerTitle:"Keywords for this product",
        addFormName:"AddProductKeyword",
        listFormName:"UpdateProductKeyword",
        addForm:new OfbizForm({
            local:true,
            formName:"AddProductKeyword",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            fields:getFields("AddProductKeyword",FEAT_TYPE_FORMS),
            appContext:"catalog"
        }),
        listForm:new OfbizList({
            listType:"grid",
            listFormName:"UpdateProductKeyword",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            appContext:"catalog",
            columnFields:getFields("UpdateProductKeyword",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("UpdateProductKeyword",FEAT_TYPE_FORMS),
            emptyListMessage:"No keywords found for this product. Please create new."
        })
        },
        {
        title:"Associations",
        titleGroup:"Product Classification",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add an associated product to this product",
        listContainerTitle:"Products associated to this product",
        addFormName:"",
        listFormName:"ListProductAssocs",
        addForm:new OfbizForm({
            local:true,
            formName:"EditProductAssoc",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            fields:getFields("EditProductAssoc",FEAT_TYPE_FORMS),
            appContext:"catalog"
        }),
        listForm:new OfbizList({
            listType:"grid",
            listFormName:"ListProductAssocs",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            columnFields:getFields("ListProductAssocs",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("ListProductAssocs",FEAT_TYPE_FORMS),
            appContext:"catalog",
            emptyListMessage:"No proucts currently associated with this product.  Associate existing product."
        })
        },
        {
        title:"Costs",
        titleGroup:"Product Acquisition",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add a Cost Components to this product",
        listContainerTitle:"Cost Components for this product",
        addFormName:"EditCostComponent",
        listFormName:"ListCostComponents",
        addForm:new OfbizForm({
            formName:"EditCostComponent",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            local:true,
            fields:getFields("EditCostComponent",FEAT_TYPE_FORMS),
            appContext:"catalog"
        }),
        listForm:new OfbizList({
            listFormName:"ListCostComponents",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            listType:"grid",
            columnFields:getFields("ListCostComponents",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("ListCostComponents",FEAT_TYPE_FORMS),
            appContext:"catalog",
            emptyListMessage:"No cost components for this product"
        })
        },
        {
        title:"Attributes",
        titleGroup:"Product Classification",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add an attribute to this product",
        listContainerTitle:"Attributes for this product",
        addFormName:"AddProductAttribute",
        listFormName:"UpdateProductAttribute",
        addForm:new OfbizForm({
            formName:"AddProductAttribute",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            local:true,
            fields:getFields("AddProductAttribute",FEAT_TYPE_FORMS),
            appContext:"catalog"
        }),
        listForm:new OfbizList({
            listType:"grid",
            listFormName:"UpdateProductAttribute",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            appContext:"catalog",
            columnFields:getFields("UpdateProductAttribute",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("UpdateProductAttribute",FEAT_TYPE_FORMS),
            emptyListMessage:"No attributes for this product"
        })
        },
        {
        title:"Features",
        titleGroup:"Product Classification",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Add a feature for this product",
        listContainerTitle:"Features for this product",
        addFormName:"AddProductFeatureApplAttrRest",
        listFormName:"ListProductFeatureApplAttrsRest",
        addForm:new OfbizForm({
            formName:"AddProductFeatureApplAttrRest",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            local:true,
            appContext:"catalog",
            fields:getFields("AddProductFeatureApplAttrRest",FEAT_TYPE_FORMS)
        }),
        listForm:new OfbizList({
            listFormName:"ListProductFeatureApplAttrsRest",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            listType:"grid",
            columnFields:getFields("ListProductFeatureApplAttrsRest",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("ListProductFeatureApplAttrsRest",FEAT_TYPE_FORMS),
            appContext:"catalog",
            emptyListMessage:"No features listed for this product"
        })
        },
        {
        title:"Facilities",
        titleGroup:"Product Storage",
        keyMap:{fieldName:"productId"},
        addContainerTitle:"Associate a facility to this product",
        listContainerTitle:"Facilities listed for this product",
        addFormName:"AddProductFacility",
        listFormName:"UpdateProductFacilities",
        addForm:new OfbizForm({
            formName:"AddProductFacility",
            formLocation:"component://kwikstore/widget/FeatureForms.xm",
            local:true,
            fields:getFields("AddProductFacility",FEAT_TYPE_FORMS),
            appContext:"catalog"
        }),
        listForm:new OfbizList({
            listFormName:"UpdateProductFacilities",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xm",
            listType:"grid",
            columnFields:getFields("UpdateProductFacilities",FEAT_TYPE_FORMS),
            columnFieldTitles:getColumnFieldTitles("UpdateProductFacilities",FEAT_TYPE_FORMS),
            emptyListMessage:"No facilities associated with this product"
        })
        },


    ], */
    customContainerItems:[
        new CustomContainerItem("EditProduct",ProductEditContainerComponent,{})
    ]

}

export const feature_type_baseMenuItems:NbMenuItem[] = [
    {title:"Product Feature Types",group:true, icon:"settings-outline"},
    {
        title:"List Product Feature Types",
        icon:"list-outline",
        link:"/admin/features/feature-types",
        data:{
            event:"list",
        }
    },
    {title:"New Product Feature Category",icon:"plus-outline"},
]
